import React from 'react';
export const Modal = ({ children, isShow, setIsShow, isCloseInside }) => {
  const closeModal = () => {
    setIsShow(false);
  };
  if (isShow) {
    return (
      <div className="mtm--modal__overlay" onClick={closeModal}>
        <div
          className={`mtm--modal__wrapper ${
            isCloseInside ? 'overflow-auto' : ''
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
          <button
            className={`mtm-modal__close ${isCloseInside ? 'inside' : ''}`}
            onClick={closeModal}
          ></button>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
